import { render } from "./DataSourceName.vue?vue&type=template&id=06fbf5d5&ts=true"
import script from "./DataSourceName.vue?vue&type=script&lang=ts"
export * from "./DataSourceName.vue?vue&type=script&lang=ts"

import "./DataSourceName.vue?vue&type=style&index=0&id=06fbf5d5&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__